import DynamicComponentError from "%/dynamic-component-editor/errors/dynamic-component-error";
import { RATIO_MODE, isWellFormedRatio } from "%/dynamic-component-editor/options/aspect-ratios";

export const RATIO_SIZE_OPTION_KEYS = Object.freeze(["layout-width", "layout-height"]);

const MSG_MALFORMED_RATIO = "malformed ratio size: expected {\"mode\":\"ratio\",\"ratio\":\"WxH\"} "
  + "with two positive whole numbers, e.g. 4x3";
const MSG_RATIO_NOT_RENDERABLE = "ratio size on an element that cannot render it: only the image elements and "
  + "Story Media declare supportsRatioSize";

export function definitionSupportsRatioSize(definition, seen = new Set()) {
  if (!definition || typeof definition !== "object" || seen.has(definition)) {
    return false;
  }
  seen.add(definition);
  if (definition.supportsRatioSize === true) {
    return true;
  }
  if (definitionSupportsRatioSize(definition.extends, seen)) {
    return true;
  }
  return (definition.mixins ?? []).some(mixin => definitionSupportsRatioSize(mixin, seen));
}

export function isRatioIntent(value) {
  if (!value || typeof value !== "object" || Array.isArray(value)) {
    return false;
  }
  return value.mode === RATIO_MODE || Object.prototype.hasOwnProperty.call(value, "ratio");
}

export function isWellFormedRatioSize(value) {
  return isRatioIntent(value) && value.mode === RATIO_MODE && isWellFormedRatio(value.ratio);
}

export function assertRenderableSizeValue({ optionKey, value, supportsRatioSize, identifier, type }) {
  if (!RATIO_SIZE_OPTION_KEYS.includes(optionKey) || !isRatioIntent(value)) {
    return;
  }
  const details = { identifier, type, optionKey, value };
  if (!isWellFormedRatioSize(value)) {
    throw new DynamicComponentError(MSG_MALFORMED_RATIO, details);
  }
  if (!supportsRatioSize) {
    throw new DynamicComponentError(MSG_RATIO_NOT_RENDERABLE, details);
  }
}

export function sizeItemsFor(items, supportsRatioSize) {
  if (supportsRatioSize) {
    return items;
  }
  return items.filter(item => item.value !== RATIO_MODE);
}
